@import 'src/styles/variabels';

.root {
  position: relative;
  display: inline-flex;
  flex-direction: column;
  margin-bottom: 0;
}
.label {
  margin-bottom: 0.4rem;
}
.inner {
  display: inline-flex;
  cursor: pointer;
}
